<template>
    <div>
        <b-alert
            variant="danger"
            :show="error"
            >
            <div v-if="errorMessage">
            {{errorMessage}}
            </div>
            <div v-else>
            {{'revisions.error_ocurred_try_again_later' | trans}}
            </div>
        </b-alert>
        <b-alert
            variant="success"
            :show="message != null && message.length > 0"
            dismissible>
            {{message}}
        </b-alert>
        <form v-show="showForm" @submit.prevent="onSubmit" @keydown="onKeyUp($event)" @change="onKeyUp($event)">
            <div>
            <inner-form
                :categories="categories"
                :months="months"
                :quarters="quarters"
                :halfYears="halfYears"
                :years="years"
                :form="form"
                :previousRevision="previousRevision"
                :error="error"
                :errorGeoCode="errorGeoCode"
                :new-form="newForm"
                ></inner-form>
            <div class="mb-4">
                <duplicates :duplicates="duplicates" :is-loading="isLoadingDuplicates"></duplicates>
            </div>    
            <div class="mb-4">
                <b-button dusk="submit-button" variant="success" @click.prevent.stop="onSubmit" :disabled="this.isSending">{{'revisions.submit' | trans}}</b-button>
            </div>
            </div>
        </form>
    </div>
</template>

<script>
import Form from "../helper/form";
import Errors from "../helper/errors";

export default {
    props: {
        categories: {
            type: Array,
            default: function () {
                return [];
            }
        },
        months: {
            type: Array,
            default: function () {
                return [];
            }
        },
        quarters: {
            type: Object,
            default: function () {
                return {};
            }
        },
        halfYears: {
            type: Object,
            default: function () {
                return {};
            }
        },
        years: {
            type: Array,
            default: function () {
                return [];
            }
        },
        revision: {
            type: Object,
            default: function () {
                return undefined;
            }
        },
        redirectBackAfterSuccess: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        isLoadingDuplicates: {
            type: Boolean,
            default: function(){
                return false;
            }
        },
        postUrl: {
            type: String,
            required: true
        },
      newForm: {
        type: String,
        required: false
      }
    },
    data: function () {
        return {
            form: new Form(
                this.revision || {
                    title: "",
                    category_id: "",
                    event_date: "",
                    select_month: "",
                    select_year_for_month: "",
                    select_quarter: "",
                    select_year_for_quarter: "",
                    select_half_year: "",
                    select_year_for_half_year: "",
                    select_year: "",
                    description: this.$cookies.get("description"),
                    street: "",
                    street_number: "",
                    postal_code: "",
                    state: "",
                    city: "",
                    phone: "",
                    website: "",
                    email: "",
                    source: "",
                    opening_times: "",
                    offer: "",
                    lat: 0,
                    lng: 0,
                    time_period: 1,
                    descinput: "",
                    entry_type: 'new_opening',
                    sales_area: null,
                    contact_person: '',
                    salutation: '',
                    unknown_contact_person: false,
                    contact_position: '',
                    contact_position_custom: ''
                },
                new Errors({})
            ),
            geocoder: null,
            previousRevision: this.revision,
            message: null,
            error: false,
            errorMessage: null,
            errorGeoCode: false,
            showForm: true,
            duplicates: [],
            isSending: false,
        };
    },
    created: function () {
      this.$gmapApiPromiseLazy().then(() => {
        this.geocoder = new google.maps.Geocoder();
      });
    },
    watch: {
        "form.street": function (val) {
            let address = val + " " + this.form.street_number + ", " + this.form.state + " " + this.form.postal_code + " " + this.form.city;
            if(address.trim().length > 1 && this.form.city.length > 1) {
                this.geocodeAddress(address);
            }
        },
        "form.street_number": function (val) {
            let address = this.form.street + " " + val + ", " + this.form.state + " " + this.form.postal_code + " " + this.form.city;
            if(address.trim().length > 1  && this.form.city.length > 1) {
                this.geocodeAddress(address);
            }
        },
        "form.postal_code": function (val) {
            let address = this.form.street + " " + this.form.street_number + ", " + this.form.state + " " + val + " " + this.form.city;
            if(address.trim().length > 1  && this.form.city.length > 1) {
                this.geocodeAddress(address);
            }
        },
        "form.city": function (val) {
            let address = this.form.street + " " + this.form.street_number + ", " + this.form.state + " " + this.form.postal_code + " " + val;
            if(address.trim().length > 1  && this.form.city.length > 1) {
                this.geocodeAddress(address);
            }
        },
        "form.state": function (val) {
            let address = this.form.street + " " + this.form.street_number + ", " + val + " " + this.form.postal_code + " " + this.form.city;
            if(address.trim().length > 1  && this.form.city.length > 1) {
                this.geocodeAddress(address);
            }
        },
        "form.event_date_pretty": function (val) {
            this.form.event_date = val.length > 0 ? $("#event_date").val() : "";
        },
        "form.title": function(val){
            this.checkDuplicates();
        }
    },
    methods: {
        clearMessages: function () {
            this.error = null;
            this.errorGeoCode = null;
        },
        onTabSelected: function (tabIndex) {
            // tabIndex starts with 0 so add 1
            this.form.time_period = tabIndex + 1;
        },
        onKeyUp: function (event) {
            this.form.errors.clear(event.target.id);
        },
        checkDuplicates: _.debounce(function(){
            this.$emit("duplicates-loading", true);
            this.form
                .checkDuplicates("post","/entries/duplicates")
                .then(response => {
                    this.duplicates = response;
                    this.$emit("duplicates-loading", false);
                    this.$emit("duplicates-change", this.duplicates);
                })
                .catch(response => {
                    this.$emit("duplicates-loading", false);
                });
        }, 1000),
        geocodeAddress: _.debounce(function (address) {
            this.geocoder.geocode({
                    address: address
                },
                function (results, status) {
                    if (status === "OK") {
                        this.form.lat = results[0].geometry.location.lat();
                        this.form.lng = results[0].geometry.location.lng();
                        this.errorGeoCode = null;
                    } else {
                        this.form.lat = 0;
                        this.form.lng = 0;
                        this.errorGeoCode = true;
                    }
                    this.checkDuplicates();
                }.bind(this)
            );
        }, 500),
        onSubmit: function () {
            this.$cookies.set("description", "", "1d");
            this.isSending = true;
            this.message = "";
            this.error = false;
            this.errorMessage = null;
            this.form
                .post(this.postUrl)
                .then(response => {
                    this.message = response.message;
                    var self = this;
                    this.form.event_date = "";
                    this.form.description = "";
                    setTimeout(function () {
                        self.message = "";
                        self.description = "";
                        if (self.redirectBackAfterSuccess) {
                            window.location = document.referrer;
                        }
                    }, 2000);
                    window.scrollTo(0, 0);
                    if (this.redirectBackAfterSuccess) {
                        this.showForm = false;
                    }
                    this.isSending = false;
                    location.reload();
                })
                .catch(response => {
                    if (response === false) {
                        this.error = true;
                    } else if (response.error) {
                        this.error = true;
                        this.errorMessage = response.error;
                    }
                    window.scrollTo(0, 0);
                    this.isSending = false;
                });
        }
    }
};
</script>
